import './gallery.scss';

export default () => {

};
